import { type FC, memo } from "react";
import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";
import { UnexpectedVector } from "./UnexpectedVector";

type ErrorInfoProps = {
  title: string;
  subtitle: string;
  description: string;
};

export const ErrorInfo: FC<ErrorInfoProps> = memo(
  ({ description, subtitle, title }) => {
    // Inlined rather than using the shared `useNavigateBack`: that hook lives
    // behind the `@hooks` barrel, and this tier must not reach a barrel.
    const navigate = useNavigate();
    const navigateBack = () => navigate(-1);
    return (
      <div className="flex gap-4 px-8 pb-8">
        <UnexpectedVector height={120} />
        <div>
          <h2 className="text-4xl font-semibold">{title}</h2>
          <h3 className="text-xl font-semibold">{subtitle}</h3>
          <p>{description}</p>
          <div className="flex mt-2">
            <Button onClick={navigateBack}>Go back!</Button>
          </div>
        </div>
      </div>
    );
  },
);
